export enum ContactChannel {
  Instagram = 'instagram',
  Email = 'email',
}

export interface ContactConfiguration {
  [ContactChannel.Instagram]: {
    handle: string
    url: string
  }
  [ContactChannel.Email]: {
    address: string
    subject: string
  }
}

export const CONTACT = {
  [ContactChannel.Instagram]: {
    handle: 'ariel.bluman',
    url: 'https://www.instagram.com/ariel.bluman/',
  },
  [ContactChannel.Email]: {
    address: 'trhtkua@gmail.com',
    subject: 'Insta Little Helper',
  },
} as const satisfies ContactConfiguration

export const PREFERRED_CONTACT = ContactChannel.Instagram

const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

export function validateContact(contact: ContactConfiguration = CONTACT): void {
  if (PREFERRED_CONTACT !== ContactChannel.Instagram) {
    throw new Error('Instagram must remain the preferred contact channel')
  }
  const instagram = contact[ContactChannel.Instagram]
  const handle = instagram.handle.trim()
  if (!handle) throw new Error('Instagram contact handle must not be empty')

  let url: URL
  try {
    url = new URL(instagram.url)
  } catch (error) {
    throw new Error('Instagram contact URL must be a valid HTTPS instagram.com URL', { cause: error })
  }
  const instagramHost = url.hostname === 'instagram.com' || url.hostname.endsWith('.instagram.com')
  if (url.protocol !== 'https:' || !instagramHost) {
    throw new Error('Instagram contact URL must be a valid HTTPS instagram.com URL')
  }
  if (url.pathname.replace(/^\/+|\/+$/g, '') !== handle) {
    throw new Error('Instagram contact URL path must match the configured handle')
  }

  const email = contact[ContactChannel.Email]
  if (!EMAIL_PATTERN.test(email.address)) throw new Error('Email contact address is invalid')
  if (!email.subject.trim()) throw new Error('Email contact subject must not be empty')
}
